import token from '@uipath/apollo-core/lib';
export const MuiIconButton = (palette) => {
    return { root: { padding: token.Padding.PadL } };
};
